import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material';
import { Router } from '@angular/router';
import { SnackBarService } from '@app/services/snack-bar.service';
import { State } from '@app/state';
import { BaseComponent } from '@components/base.component';
import { MasterSettingService } from '@services/master-setting.service';
import { Breadcrumb } from '@app/models/view-models/breadcrumb';
@Component({
  selector: 'app-master-settings-index',
  templateUrl: './master-settings-index.component.html',
  styleUrls: ['./master-settings-index.component.scss']
})
export class MasterSettingsIndexComponent extends BaseComponent implements OnInit {
  public dataSource: any;
  public node: Breadcrumb;
  public data: any;
  public displayedColumns = ['name', 'group_title', 'function', 'type_title', 'actions'];
  public dataLoaded = false;
  constructor(
    public masterSettingService: MasterSettingService,
    public router: Router,
    public state: State,
    public snackbarService: SnackBarService,
    public dialog: MatDialog
  ) {
    super();
    this.setObjects({
      modelService: masterSettingService,
      router,
      state,
      snackbarService,
      dialog
    });

    this.setPageVars({
      listenForIndexUpdate: true
    });
    this.modelServiceGetAll().then(() => (this.dataLoaded = true));
  }

  public updatedStatus(): void {
    this.state.message({ ['MasterSettingIndexUpdate']: true });
  }

  ngOnInit(): void {
    super.ngOnInit();
    this.node = {
      label: 'Master Settings',
      link: 'master-settings',
      title: 'Master Settings'
    };
    this.buildSettingsBreadcrumb(this.node);
  }
}
